import React, { useEffect, useState, useContext } from "react";
import ArrowSvg from "../../assets/svg/arrowSvg";
import defaultProfilePicture from "../../assets/images/defaultProfilePicture.png";

import developerIconLight from "../../assets/images/codeLight.png";
import notificationsIconLight from "../../assets/images/notificationsIcon.png";
import messagesIconLight from "../../assets/images/messagesIconLight.png";
import contactsIconLight from "../../assets/images/contactsLight.png";
import sharedIconLight from "../../assets/images/sharedLight.png";
import supportIconLight from "../../assets/images/supportLight.png";
import trashIconLight from "../../assets/images/trashIconLight.png";
import settingsIconLight from "../../assets/images/setting-linesLight.png";

import { UserContext } from "../../context/UserContext";

import "./sideNav.css";
import { useNavigate } from "react-router-dom";
import { Alert, GetSessionUrls, SetLocalSetting, TrackSessionUrl, TruncateText } from "../../utils/genericUtils";
import SideNavButton from "./sideNav-button";
import { ProfilePictureModal } from "../Modals/EditProfilePictureModal/edit-profile-picture-modal";

import { GetFile } from "../../utils/httpUtils";
import { AlertContext } from "../../context/AlertContext";

function SideNav() {
  const [sideNavOpen, setSideNavOpen] = useState(true);
  const { user, loginUser } = useContext(UserContext);
  const { globalAlert } = useContext(AlertContext);

  const [profilePicture, setProfilePicture] = useState(defaultProfilePicture);
  const [showProfilePictureModal, setShowProfilePictureModal] = useState(false);

  const [forceUpdate, setForceUpdate] = useState(false);

  const router = useNavigate();

  useEffect(() => {
    let profile_picutre_session_url = GetSessionUrls().find((x) => x.objectId === "__profile_picture");

    if (profile_picutre_session_url) {
      setProfilePicture(profile_picutre_session_url.url);
    } else {
      if (user && user.profilePictureUrl !== null && user.profilePictureUrl !== "" && user.profilePictureUrl.toLowerCase() !== "null ") {
        GetFile(user.profilePictureUrl, user).then((file) => {
          if (file && file.url) {
            TrackSessionUrl("__profile_picture", file.url);
            setProfilePicture(file.url);
          }
        });
      }
    }
  }, [forceUpdate]);

  const nav_buttons = [
    {
      icon: notificationsIconLight,
      iconAlt: "Notifications",
      name: "Notifications",
      active: false,
      onClick: () => {},
    },
    {
      icon: messagesIconLight,
      iconAlt: "Messages",
      name: "Messages",
      active: false,
      onClick: () => {},
    },
    {
      icon: contactsIconLight,
      iconAlt: "Contacts",
      name: "Contacts",
      active: false,
      onClick: () => {},
    },
    {
      icon: sharedIconLight,
      iconAlt: "trash bin icon",
      name: "Shared",
      active: false,
      onClick: () => {},
    },
    {
      icon: supportIconLight,
      iconAlt: "trash bin icon",
      name: "Support",
      active: false,
      onClick: () => {},
    },
    {
      icon: developerIconLight,
      iconAlt: "Developer",
      name: "Developer",
      active: true,
      onClick: () => {
        Alert(globalAlert, "info", "Coming Soon", "This feature is currently in development. Stay tuned for future updates!");
      },
    },
    {
      icon: settingsIconLight,
      iconAlt: "Settings",
      name: "Settings",
      active: true,
      onClick: () => {
        router("/settings");
      },
    },

    {
      icon: trashIconLight,
      iconAlt: "trash bin icon",
      name: "Trash",
      active: true,
      onClick: () => {
        router("/dashboard/trash");
      },
    },
  ];

  function toggleSideNav() {
    let sideNav = document.querySelector("#side-nav");
    let profileSection = sideNav.querySelector(".profile-section");
    let arrow = document.querySelector("#side-nav-arrow");
    let buttons = document.querySelectorAll(".side-nav-button button");
    let otherElements = document.querySelectorAll(".hide-on-collapse");
    if (sideNavOpen) {
      //closed
      setSideNavOpen(false);
      sideNav.style.maxWidth = "60px";
      profileSection.style.flexDirection = "column";
      arrow.style.transform = "rotate(0deg)";
      arrow.style.marginBottom = "0px";
      arrow.parentElement.style.marginTop = "5px";
      arrow.style.marginTop = "5px";
      arrow.style.marginRight = "auto";
      buttons.forEach((btn) => (btn.style.width = "80%"));
      otherElements.forEach((el) => {
        el.style.display = "none";
      });
    } else {
      //open
      setSideNavOpen(true);
      sideNav.style.maxWidth = "250px";
      profileSection.style.flexDirection = "row";
      arrow.style.marginBottom = "5px";
      arrow.style.marginTop = "0px";
      arrow.style.transform = "rotate(180deg)";
      arrow.style.marginRight = "5px";
      buttons.forEach((btn) => (btn.style.width = "100%"));
      setTimeout(() => {
        otherElements.forEach((el) => {
          el.style.display = "initial";
        });
      }, 200);
    }
  }

  function renderSideNavButtons() {
    if (user && user.settings && user.settings.developer_mode === false) {
      let developer_option = nav_buttons.find((x) => x.name === "Developer");
      developer_option.active = false;
    }

    return nav_buttons.filter((x) => x.active === true).map((button, index) => <SideNavButton key={`side-nav-button-${index}`} {...button} />);
  }

  if (user == null) return <></>;

  return (
    <>
      {/*Side Menu Component*/}
      {/*Profile Picture*/}
      {/*Welcome Back [Username]*/}
      {/*Plan Info*/} {/*Upgrade Plan*/}
      {/*Account Settings -- contains edit info and cancel subscription options*/}
      {/*Contacts*/}
      {/*Storage Info section, free storage*/}
      {/*Upload Button*/} {/*Create Folder*/}
      <nav id="side-nav" className="side-nav">
        <section className="profile-section">
          {/* PROFILE PICTURE COMPONENT */}
          <ProfilePictureModal
            id="side-nav-profile-picture-modal"
            isActive={showProfilePictureModal}
            onCloseModal={() => setShowProfilePictureModal(false)}
            onClickOut={() => setShowProfilePictureModal(false)}
            forceUpdate={() => setForceUpdate(true)}
          />
          <div className="profile-picture-container" onClick={() => setShowProfilePictureModal(true)}>
            <img
              className="profile-picture"
              src={profilePicture}
              alt="user profile picture"
              onError={(e) => {
                e.target.src = defaultProfilePicture;
                SetLocalSetting("__profile_picture", null);
              }}
            />
          </div>

          <div className="welcome-back-container hide-on-collapse">
            <h5 className="welcome-back-text">Welcome Back,</h5>
            <p className="user-full-name-text">{TruncateText(user.firstName + " " + user.lastName, 17)}</p>
          </div>

          <div className="nav-collapse-arrow-container" onClick={toggleSideNav}>
            <ArrowSvg id="side-nav-arrow" class="nav-collapse-arrow" />
          </div>
        </section>

        <section className="plan-info">
          <h4 className="hide-on-collapse subscription-text">Subscription: </h4>
          <h4 className="hide-on-collapse plan-text">{user.subscription ? user.subscription.toUpperCase() : "Free"}</h4>
          {/* <button
            onClick={() => {
              router("/settings");
            }}
            id="settings-button"
            className="settings-icon-button">
            <img className="settings-icon-img" src={settingsIcon} alt="settings button" />
          </button> */}
        </section>

        {/* SIDE NAV BUTTONS */}
        {renderSideNavButtons()}
      </nav>
    </>
  );
}

export default SideNav;
